import React from "react";
import PropTypes from "prop-types";

const SortingIcon = ({visible, reversed}) => {
    if (!visible) return '';
    if (reversed) return (<i className="fa fa-fw fa-caret-down"/>);
    return (<i className="fa fa-fw fa-caret-up"/>);
};
SortingIcon.propTypes = {
    visible: PropTypes.bool,
    reversed: PropTypes.bool
};

export default SortingIcon;